exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RangeInput__input___KmUoK > input[type=\"text\"] {\n  font-size: 14px;\n  line-height: 2.14;\n  text-align: left;\n  color: #292929; }\n", ""]);

// exports
exports.locals = {
	"input": "RangeInput__input___KmUoK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/RangeControl/RangeInput.scss
// module id = 2168
// module chunks = 6